export interface IRecommendedRatios {
  width: number;
  height: number;
  ratio: string;
  type: string;
  mask: {
    width: number;
    height: number;
  };
}

export const recommendedRatios: IRecommendedRatios[] = [
  {
    width: 576, height: 1024, ratio: '9 : 16', type: '宣传海报',
    mask: {
      width: 18, height: 34,
    },
  },
  {
    width: 1024, height: 1024, ratio: '1 : 1', type: '头像特写',
    mask: {
      width: 34, height: 34,
    },
  },
  {
    width: 512, height: 1024, ratio: '1 : 2', type: '手机浏览',
    mask: {
      width: 17, height: 34,
    },
  },
  {
    width: 1024, height: 768, ratio: '4 : 3', type: '文章配图',
    mask: {
      width: 34, height: 26,
    },
  },
  {
    width: 768, height: 1024, ratio: '3 : 4', type: '社交媒体',
    mask: {
      width: 26, height: 34,
    },
  },
  {
    width: 1024, height: 576, ratio: '16 : 9', type: '电脑壁纸',
    mask: {
      width: 34, height: 18,
    },
  },
];
